import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { SET_LANG } from '../../../store/types';
import { device } from '../../../utils/constants';
import LayoutNosotros from '../nosotros/layoutNosotros';
import BannerServicios from './banner.servicios';
import CastingServicios from './casting.servicios';
import DirectorServicios from './director.servicios';
import FooterServicios from './footer.servicios';
import HeaderServicios from './header.servicios';
import LocationServicios from './location.servicios';
import LogisticasServicios from './logisticas.servicios';
import NosotrosServicios from './nosotros.servicios';

export const RED_COLOR = '#bc2c24';

const SeviciosPages = () => {
  const dispatch = useDispatch();

  const mobile = useMediaQuery({ query: device.mobile });

  useEffect(() => {
    const lang =
      window.localStorage.getItem('i18nextLngPLP') === 'en' ? 'en' : 'es';
    dispatch({
      type: SET_LANG,
      payload: lang,
    });
  }, []);

  return (
    <LayoutNosotros
      notHeader
      footer={false}
      isWhiteLang={false}
      menuBlack={mobile}
      noLogo
    >
      <HeaderServicios />
      <BannerServicios />
      <LocationServicios />
      <LogisticasServicios />
      <CastingServicios />
      <NosotrosServicios />
      <DirectorServicios />
      <FooterServicios />
    </LayoutNosotros>
  );
};

export default SeviciosPages;
